"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContentColumns = exports.useColumns = void 0;
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const table_field_cells_1 = require("../../../components/table-field/table-field-cells");
const table_cells_1 = require("../../../composite/table/table-cells");
const table_filter_cells_1 = require("../../../composite/table/table-filter-cells");
const signing_api_1 = require("../signing-api");
/**
 * fixme: add record and components, type
 */
function useColumns() {
    const intl = react_intl_1.useIntl();
    return [
        {
            datakey: 'name',
            name: intl.formatMessage({
                id: 'EAS_SIGNING_REQUESTS_COLUMN_NAME',
                defaultMessage: 'Název',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'user',
            displaykey: 'user.name',
            sortkey: 'user.name',
            filterkey: 'user.name',
            name: intl.formatMessage({
                id: 'EAS_SIGNING_REQUESTS_COLUMN_USER',
                defaultMessage: 'Uživatel',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'state',
            sortkey: 'state.name',
            filterkey: 'state.id',
            name: intl.formatMessage({
                id: 'EAS_SIGNING_REQUESTS_COLUMN_STATE',
                defaultMessage: 'Stav',
            }),
            width: 150,
            CellComponent: table_cells_1.TableCells.TextCell,
            FilterComponent: table_filter_cells_1.TableFilterCells.useFilterSelectCellFactory(signing_api_1.useRequestStates),
            valueMapper: table_cells_1.TableCells.useSelectCellFactory(signing_api_1.useRequestStates),
            sortable: true,
            filterable: true,
        },
        {
            datakey: 'error',
            name: intl.formatMessage({
                id: 'EAS_SIGNING_REQUESTS_COLUMN_ERROR',
                defaultMessage: 'Chyba',
            }),
            width: 200,
            CellComponent: table_cells_1.TableCells.TextCell,
            sortable: true,
            filterable: true,
        },
    ];
}
exports.useColumns = useColumns;
function useContentColumns() {
    const intl = react_intl_1.useIntl();
    return react_1.useMemo(() => [
        {
            datakey: 'toSign',
            name: intl.formatMessage({
                id: 'EAS_SIGNING_CONTENTS__COLUMN_TO_SIGN',
                defaultMessage: 'K podepsání',
            }),
            width: 250,
            CellComponent: table_field_cells_1.TableFieldCells.FileCell,
        },
        {
            datakey: 'signed',
            name: intl.formatMessage({
                id: 'EAS_SIGNING_CONTENTS__COLUMN_SIGNED',
                defaultMessage: 'Podepsáno',
            }),
            width: 250,
            CellComponent: table_field_cells_1.TableFieldCells.FileCell,
        },
    ], [intl]);
}
exports.useContentColumns = useContentColumns;
//# sourceMappingURL=requests-columns.js.map